import { QueryClient } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'

const isProdOrStaging = ['production', 'staging', 'strabag'].includes(
  import.meta.env.VITE_TARGET_ENV
)

export const customQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 3,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 300000), // Exponential backoff
      onError: (error) => {
        if (isProdOrStaging && Sentry) {
          Sentry.captureException(error)
        }
      }
    },
    mutations: {
      retry: 3,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000), // Exponential backoff
      onError: (error) => {
        if (isProdOrStaging && Sentry) {
          Sentry.captureException(error)
        }
      }
    }
  }
})
